import { useDispatch, useSelector } from "react-redux";
import { set } from "../redux/aiDiagnosisTestData";

const getLearner = state => state.aiDiagnosisTestData;

const useAiDiagnosisTestData = () => {

  const dispatch = useDispatch();
  const aiDiagnosisTestData = useSelector( getLearner );
  const setAiDiagnosisTestData = data => { dispatch( set( data ) ) };

  return {
    aiDiagnosisTestData,
    setAiDiagnosisTestData
  };

};

export default useAiDiagnosisTestData;

